import { Skeleton } from "components/ui/skeleton";

// Mirrors CaseMapSidebarRow's own structure — checkbox, identifier and badges,
// three label/value lines, then the event count — so the list does not reflow
// when the real rows arrive.
export function CaseMapSidebarRowSkeleton({ selectable }) {
  return (
    <div
      aria-hidden
      className="tw:flex tw:w-full tw:items-start tw:gap-2 tw:border-b tw:border-(--color-border) tw:px-3 tw:py-2"
    >
      {selectable && <Skeleton className="tw:mt-1 tw:size-4 tw:shrink-0" />}

      <div className="tw:flex tw:min-w-0 tw:flex-1 tw:flex-col tw:gap-1">
        <div className="tw:flex tw:items-center tw:gap-2">
          <Skeleton className="tw:h-4 tw:w-24" />
          <Skeleton className="tw:h-5 tw:w-16 tw:rounded-sm" />
          <Skeleton className="tw:h-5 tw:w-20 tw:rounded-sm" />
        </div>

        <Skeleton className="tw:h-3.5 tw:w-40" />
        <Skeleton className="tw:h-3.5 tw:w-32" />
        <Skeleton className="tw:h-3.5 tw:w-44" />

        <div className="tw:flex tw:items-center tw:gap-1.5">
          <Skeleton className="tw:size-3" />
          <Skeleton className="tw:h-3.5 tw:w-28" />
        </div>
      </div>
    </div>
  );
}

/** A placeholder list, long enough to fill the pane while the case loads. */
export function CaseMapSidebarSkeleton({ selectable, rows = 8 }) {
  return (
    <div aria-busy="true" aria-label="Loading machines">
      {Array.from({ length: rows }, (_, index) => (
        <CaseMapSidebarRowSkeleton key={index} selectable={selectable} />
      ))}
    </div>
  );
}
